import { MutationTree } from 'vuex'
import { ISidebarState } from './types'

const mutations: MutationTree<ISidebarState> = {
  reset(state) {
    state.isSidebarOpen = false
    state.isSettingsPanelOpen = false
    state.isWhatsNewPanelOpen = false
    state.enableHelpPanel = false
  },

  setSidebarOpen(state, value) {
    state.isSidebarOpen = value
  },

  setSettingsPanelOpen(state, value) {
    state.isSettingsPanelOpen = value
  },

  setWhatsNewPanelOpen(state, value) {
    state.isWhatsNewPanelOpen = value
  },

  setHelpPanelOpen(state, value) {
    if (state.enableHelpPanel === false) {
      state.isHelpPanelOpen = false
    } else {
      state.isHelpPanelOpen = value
    }
  },

  setEnableHelpPanel(state, value) {
    let enabled = false
    if (typeof value === 'string' && /^\s*false\s*$/i.test(value)) {
      enabled = false
    } else {
      enabled = Boolean(value);
    }
    state.enableHelpPanel = enabled
  }
}

export default mutations

